import { useDispatch, useSelector } from "react-redux";
import ProjectAction from "../actions/ProjectAction";
import FieldList from "./FieldList";
import GridAction from "../actions/GridAction";
import { DialogTypes } from "../constants/action-types";
import CustomFieldDialog from "../dialog/CustomFieldDialog";
import { deleteField } from "../api/ProjectApi";
import { useQuery } from "../AppLayout";
import { useTranslation } from "react-i18next";

const FieldsSetting = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const project = useSelector((state: any) => state.projectReducer.get("project"));
  const fields = project.get("fields");
  const formType = useQuery().get("type");

  const renderAddFieldDialog = () => {
    return (
      <CustomFieldDialog
        onClose={() => {
          dispatch(GridAction.hideTaskDialog());
        }}
        onSubmit={() => {
          dispatch(ProjectAction.getProject(project.get("id")));
          dispatch(GridAction.hideTaskDialog());
        }}
        onDelete={async (customFieldId) => {
          try {
            await deleteField(project.get("id"), customFieldId);
          } catch (error: any) {
            // Ignore 500 errors as data is still processed successfully on the backend
            if (error?.response?.status !== 500) {
              throw error;
            }
          }
          dispatch(ProjectAction.getProject(project.get("id")));
          dispatch(GridAction.hideTaskDialog());
        }}
        title={t("Custom Field")}
      />
    );
  };

  const renderView = () => {
    return (
      <FieldList
        fields={fields}
        formType={formType}
        onShowEditField={(fieldID, type) => {
          dispatch(GridAction.showGridDialog(fieldID, DialogTypes.updateCustomFieldDialog, type));
        }}
        onAddNewField={(contentType) => {
          dispatch(
            GridAction.showGridDialog(undefined, DialogTypes.createCustomFieldDialog, contentType)
          );
        }}
      />
    );
  };

  return (
    <>
      {renderView()}
      {renderAddFieldDialog()}
    </>
  );
};

export default FieldsSetting;
